module.exports = __webpack_public_path__ + "img/close_icon.dd4f8c6a.svg";